function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import renderIf from '@signal/utils/renderIf';
import componentPropType from '@signal/prop-types/component';
import Expandable from '../Expandable';
import { EventContentWrapper, EventTime, EventSubtitle, EventSubcontent, EventSubcontentItem, ExpandButton, ExpandButtonText, ExpandableWrapper } from './styles';

var TimelineGroup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TimelineGroup, _React$PureComponent);

  var _super = _createSuper(TimelineGroup);

  function TimelineGroup() {
    var _this;

    _classCallCheck(this, TimelineGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      collapsed: {}
    });

    _defineProperty(_assertThisInitialized(_this), "getTime", function (item) {
      return format(item.time, 'h:mm a');
    });

    return _this;
  }

  _createClass(TimelineGroup, [{
    key: "handleToggleCollapse",
    value: function handleToggleCollapse(item) {
      this.setState(function (_ref) {
        var collapsed = _ref.collapsed;
        return {
          collapsed: _objectSpread(_objectSpread({}, collapsed), {}, _defineProperty({}, item.id, !collapsed[item.id]))
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          item = _this$props.item,
          showTime = _this$props.showTime,
          Wrapper = _this$props.wrapperComponent,
          rest = _objectWithoutProperties(_this$props, ["item", "showTime", "wrapperComponent"]);

      var collapsed = this.state.collapsed;
      return /*#__PURE__*/React.createElement(Wrapper, rest, renderIf(item.time && showTime, function () {
        return /*#__PURE__*/React.createElement(EventTime, null, _this2.getTime(item));
      }), renderIf(item.subtitle, function () {
        return /*#__PURE__*/React.createElement(EventSubtitle, null, item.subtitle);
      }), renderIf(item.items, function () {
        return /*#__PURE__*/React.createElement(ExpandableWrapper, null, /*#__PURE__*/React.createElement(Expandable, null, renderIf(collapsed[item.id] === true, function () {
          return /*#__PURE__*/React.createElement(EventSubcontent, null, item.items.map(function (item, i) {
            return /*#__PURE__*/React.createElement(EventSubcontentItem, {
              key: i
            }, item);
          }));
        })), /*#__PURE__*/React.createElement(ExpandButton, {
          onClick: function onClick() {
            return _this2.handleToggleCollapse(item);
          }
        }, /*#__PURE__*/React.createElement(ExpandButtonText, null, renderIf(collapsed[item.id] === true, 'collapse', 'expand'))));
      }));
    }
  }]);

  return TimelineGroup;
}(React.PureComponent);

TimelineGroup.defaultProps = {
  getKey: function getKey(item) {
    return item.id;
  },
  wrapperComponent: EventContentWrapper
};
TimelineGroup.propTypes = {
  showTime: PropTypes.bool,
  item: PropTypes.object,
  wrapperComponent: componentPropType
};
export default TimelineGroup;